export class Score {
  id: number;
  userId: number;
  tourId: number;
  modeId: number;
  spotId: number;
}
